import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import Select from "react-select";

const AdminAddEducation = () => {
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    about: "",
    youtube_link: "",
    category_ids: [], // array to store all selected category ids
  });

  const [level1Options, setLevel1Options] = useState([]);
  const [level2Options, setLevel2Options] = useState([]);
  const [level3Options, setLevel3Options] = useState([]);

  const [selectedLevel1, setSelectedLevel1] = useState(null);
  const [selectedLevel2, setSelectedLevel2] = useState(null);
  const [selectedLevel3, setSelectedLevel3] = useState(null);

  const [pdfFile, setPdfFile] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${baseurl}getAllEducationCategories`);
        const cats = res.data.data || [];
        setCategories(cats);

        // Level 1 categories: parent_id == null
        setLevel1Options(
          cats.filter((cat) => !cat.parent_id).map((cat) => ({
            value: cat.id,
            label: cat.education_title,
          }))
        );
      } catch (err) {
        console.error("Error fetching categories", err);
      }
    };
    fetchCategories();
  }, []);

  const handleFileChange = (e) => {
    setPdfFile(e.target.files[0]);
  };

  const handleLevel1Change = (options) => {
  setSelectedLevel1(options || []);
  setSelectedLevel2([]);
  setSelectedLevel3([]);

  // Level 2 options based on all selected level 1 ids
  const level1Ids = (options || []).map((opt) => opt.value);
  setLevel2Options(
    categories
      .filter((cat) => level1Ids.includes(cat.parent_id))
      .map((cat) => ({ value: cat.id, label: cat.education_title }))
  );
  setLevel3Options([]);

  // Update category_ids with all selected ids
  setFormData((prev) => ({
    ...prev,
    category_ids: level1Ids,
  }));
};

// Level 2 Change
const handleLevel2Change = (options) => {
  setSelectedLevel2(options || []);
  setSelectedLevel3([]);

  const level2Ids = (options || []).map((opt) => opt.value);

  // Level 3 options based on all selected level 2 ids
  setLevel3Options(
    categories
      .filter((cat) => level2Ids.includes(cat.parent_id))
      .map((cat) => ({ value: cat.id, label: cat.education_title }))
  );

  // Update category_ids combining level1 + level2
  const level1Ids = selectedLevel1.map((opt) => opt.value);
  setFormData((prev) => ({
    ...prev,
    category_ids: [...level1Ids, ...level2Ids],
  }));
};

// Level 3 Change
const handleLevel3Change = (options) => {
  setSelectedLevel3(options || []);
  const level3Ids = (options || []).map((opt) => opt.value);

  const level1Ids = selectedLevel1.map((opt) => opt.value);
  const level2Ids = selectedLevel2.map((opt) => opt.value);

  setFormData((prev) => ({
    ...prev,
    category_ids: [...level1Ids, ...level2Ids, ...level3Ids],
  }));
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  const data = new FormData();

  Object.entries(formData).forEach(([key, value]) => {
    // Send category_ids as array
    if (Array.isArray(value)) data.append(key, JSON.stringify(value));
    else data.append(key, value);
  });

  if (pdfFile) data.append("pdf", pdfFile);

   // Log all form data before sending
  console.log("Submitting the following form data:");
  for (let pair of data.entries()) {
    console.log(`${pair[0]}:`, pair[1]);
  }
  

  try {
    await axios.post(`${baseurl}addEducation`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    Swal.fire({
      icon: "success",
      title: "Success!",
      text: "Education profile added successfully!",
      timer: 2000,
      showConfirmButton: false,
    });
    navigate("/admin/all-education");
  } catch (err) {
    console.error(err);
    Swal.fire({ icon: "error", title: "Error", text: "Failed to add profile." });
  }
};

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <h4 className="mb-3">Add Education</h4>

          <div className="card p-4">
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="row g-3">
                <div className="col-md-12">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Name"
                    required
                  />
                </div>

                <div className="col-md-12">
                  <textarea
                    name="about"
                    value={formData.about}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Write About Yourself"
                    rows={4}
                    required
                  />
                </div>

                <div className="col-md-12">
                  <input
                    type="text"
                    name="youtube_link"
                    value={formData.youtube_link}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter YouTube Link"
                  />
                </div>

                {/* Multi-level React-Select */}
                <div className="col-md-4">
                  <label className="form-label">What We Do</label>
                  <Select
  isMulti
  closeMenuOnSelect={false}
  options={level1Options}
  value={selectedLevel1}
  onChange={handleLevel1Change}
  placeholder="Select What We Do"
/>
                </div>

                {level2Options.length > 0 && (
                  <div className="col-md-4">
                    <label className="form-label">Category</label>
                    <Select
  isMulti
  closeMenuOnSelect={false}
  options={level2Options}
  value={selectedLevel2}
  onChange={handleLevel2Change}
  placeholder="Select Category"
/>
                  </div>
                )}

                {level3Options.length > 0 && (
                  <div className="col-md-4">
                    <label className="form-label">Sub-Category</label>
                    <Select
  isMulti
  closeMenuOnSelect={false}
  options={level3Options}
  value={selectedLevel3}
  onChange={handleLevel3Change}
  placeholder="Select Sub-Category"
/>
                  </div>
                )}

                <div className="col-md-12">
                  <label className="form-label">Upload PDF Document</label>
                  <input
                    type="file"
                    accept="application/pdf"
                    className="form-control"
                    onChange={handleFileChange}
                  />
                </div>

                <div className="col-12 mt-3">
                  <button type="submit" className="btn btn-primary w-100">
                    Submit Profile
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAddEducation;
